module.exports = __webpack_public_path__ + "static/media/de_tt7_camper.a935279a.jpg";